import Model from 'src/storage/base';

class PublicModel extends Model {
  id = 'PublicModel';
  persistent = false;

  apiConfig = {
    code: {
      url: 'auth/code',
      validation: {
        code: 'code'
      },
      cancellable: true
    },
    account: {
      url: 'account/detail',
      validation: {
        username: 'username'
      }
    },
    accountId: {
      url: 'account/detail',
      validation: {}
    },
    emailSubscription: {
      url: 'email/subscription',
      validation: {},
      cancellable: true
    }
  };

  checkCode(code, cb) {
    this.api('code', { code }, cb);
  }

  accountDetail(username, cb) {
    if (this.validate('username', username, 'account')) return cb('Invalid username');
    this.api('account', { username }, cb);
  }

  accountDetailById(id, cb) {
    if (this.validate('id', id, '/email/subscription/detail')) return cb('Invalid username');
    this.api('/email/subscription/detail', { id }, cb);
  }
  emailSubscription = (id, email_subscription, cb) => {
    this.api(
      'emailSubscription',
      {
        id,
        email_subscription
      },
      cb
    );
  };
}

const model = new PublicModel();
export default model;
